import { render, staticRenderFns } from "./sensor-history.vue?vue&type=template&id=04a8a7aa&scoped=true"
import script from "./sensor-history.vue?vue&type=script&lang=js"
export * from "./sensor-history.vue?vue&type=script&lang=js"
import style0 from "./sensor-history.vue?vue&type=style&index=0&id=04a8a7aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a8a7aa",
  null
  
)

export default component.exports